import { useState } from "react";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import ReviewDialog from "@/components/schema/ReviewDialog";

// Runs `call({dryRun, allowOlder})` as a dry run first, shows the review, saves only on Confirm.
export function useReviewFlow(onSaved) {
  const [state, setState] = useState({ open: false, title: "", result: null, call: null, busy: false });

  const start = async (title, call) => {
    try {
      const { data } = await call({ dryRun: true, allowOlder: false });
      setState({ open: true, title, result: data, call, busy: false });
    } catch (e) {
      const d = e.response?.data?.detail;
      if (d && typeof d === "object" && d.errors) {
        setState({ open: true, title, result: { ok: false, errors: d.errors, warnings: [], changes: [] }, call, busy: false });
      } else toast.error(formatApiError(d) || e.message);
    }
  };

  const confirm = async () => {
    setState((s) => ({ ...s, busy: true }));
    try {
      const { data } = await state.call({ dryRun: false, allowOlder: !!state.result?.requires_overwrite_confirmation });
      toast.success(data.saved ? "Saved" : "Nothing to save");
      setState((s) => ({ ...s, open: false, busy: false }));
      onSaved && onSaved(data);
    } catch (e) {
      setState((s) => ({ ...s, busy: false }));
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    }
  };

  const dialog = (
    <ReviewDialog open={state.open} title={state.title} result={state.result} busy={state.busy}
      onClose={() => setState((s) => ({ ...s, open: false }))} onConfirm={confirm} />
  );
  return { start, dialog };
}

